import { render } from "./ModalDecision.vue?vue&type=template&id=e9028fb2&ts=true"
import script from "./ModalDecision.vue?vue&type=script&lang=ts"
export * from "./ModalDecision.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__